import BaseComponent from "./BaseComponent";

export default class PlaceholderReplacer extends BaseComponent {
    constructor() {
        super();

        this._elementsWithPlaceholder = null;

        this._initPlaceholderReplacement();
    }

    _initPlaceholderReplacement() {
        this._elementsWithPlaceholder = Array.from(document.querySelectorAll('.blb-input[name$="_custom_placeholder]"]'));

        this._clearPlaceholders();
    }

    _clearPlaceholders() {
        this._elementsWithPlaceholder.forEach((e) => {
            let el = e;

            el.setAttribute('placeholder', '');
        });
    }
}
